import jsCookie from 'js-cookie';

export const SEARCH_COOKIE = 'ha-trip-prst';

const defaultValues = {
    departureDate: null,
    arrivalDate: null,
    adultsCount: 0,
    childrenCount: 0,
    petIncluded: false,
};

export function removeKeysFromSearchCookie(...keys) {
    const cookie = jsCookie.getJSON(SEARCH_COOKIE);

    if (!cookie) {
        return;
    }

    for (let key of keys) {
        delete cookie[key];
    }

    jsCookie.set(SEARCH_COOKIE, cookie);
}

export function removeDatesFromSearchCookie() {
    removeKeysFromSearchCookie('arrival', 'departure');
}

export function removeGuestDataFromSearchCookie() {
    removeKeysFromSearchCookie(
        'numberOfAdults',
        'numberOfChildren',
        'petIncluded'
    );
}

export function getDatesFromCookie() {
    const searchData = jsCookie.getJSON(SEARCH_COOKIE);

    if (!searchData) {
        return defaultValues;
    }

    const {
        arrival = null,
        departure = null,
        numberOfAdults = 0,
        numberOfChildren = 0,
        petIncluded = false,
    } = searchData;

    const arrivalMs = Date.parse(arrival);
    const departureMs = Date.parse(departure);

    const todayMs = Date.parse(new Date().toISOString().split('T')[0]);

    const cookieValues = {
        departureDate: null,
        arrivalDate: null,
        adultsCount: numberOfAdults ? parseInt(numberOfAdults, 10) : 0,
        childrenCount: numberOfChildren ? parseInt(numberOfChildren, 10) : 0,
        petIncluded: /true/i.test(petIncluded),
    };

    if (
        arrival &&
        departure &&
        arrivalMs >= todayMs &&
        arrivalMs < departureMs
    ) {
        cookieValues.arrivalDate = arrival;
        cookieValues.departureDate = departure;
    }

    return cookieValues;
}
